export default class LocalStorageManager {
  static setUser (user) {
    localStorage.setItem('APP_USER', JSON.stringify(user))
  }

  static removeUser () {
    if (typeof localStorage['APP_USER'] !== 'undefined') { localStorage.removeItem('APP_USER') }
  }

  static getUser () {
    if (typeof localStorage['APP_USER'] !== 'undefined' && localStorage['APP_USER'] !== 'undefined') { return JSON.parse(localStorage.getItem('APP_USER')) }
  }

  static setUserToken (userToken) {
    localStorage.setItem('APP_USER_TOKEN', JSON.stringify(userToken))
  }

  static removeUserToken () {
    if (typeof localStorage['APP_USER_TOKEN'] !== 'undefined') { localStorage.removeItem('APP_USER_TOKEN') }
  }

  static getUserToken () {
    if (typeof localStorage['APP_USER_TOKEN'] !== 'undefined' && localStorage['APP_USER_TOKEN'] !== 'undefined') { return JSON.parse(localStorage.getItem('APP_USER_TOKEN')) }
  }

  static setCompanyToken (companyToken) {
    localStorage.setItem('APP_COMPANY_TOKEN', JSON.stringify(companyToken))
  }

  static removeCompanyToken () {
    if (typeof localStorage['APP_COMPANY_TOKEN'] !== 'undefined') { localStorage.removeItem('APP_COMPANY_TOKEN') }
  }

  static getCompanyToken () {
    if (typeof localStorage['APP_COMPANY_TOKEN'] !== 'undefined' && localStorage['APP_COMPANY_TOKEN'] !== 'undefined') { return JSON.parse(localStorage.getItem('APP_COMPANY_TOKEN')) }
  }

  static clearLocalStorage () {
    localStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/utils/LocalStorageManager.js